import { Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AbstractComponent, Flow, FlowService } from 'lib-trend-core';
import { environment } from "../../../../environments/environment";
import { ThemeService } from '../../../services/theme.service';

@Component({
    selector: 'flow-embeded-component',
    templateUrl: 'flow-embeded.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FlowEmbededComponent extends AbstractComponent implements OnInit, OnDestroy {

  flow: Flow;
  urlEmbeded: SafeResourceUrl = undefined;

  @ViewChild('flowFrame') private flowFrame: ElementRef<HTMLIFrameElement>;

  private idFlow: string;
  private readonly editorOrigin = new URL(environment.trendFlow).origin;
  private readonly onEditorMessage = (event: MessageEvent) => this.handleEditorMessage(event);

  constructor(
    injector: Injector,
    private domSanitizer: DomSanitizer,
    public flowService: FlowService,
    private themeService: ThemeService,
  ) {
    super(injector);
  }

  ngOnInit() {
    // Condense the app sidebar while editing a flow — same mechanism as the attendance panel
    // (the header collapses on this signal; the sidebar keeps the state on this route).
    this.themeService.toggleExpandSidebar(false);

    this.idFlow = super.getParam('idFlow');
    // The editor (trendmulti-web-flow) is a separate React app served at environment.trendFlow.
    // It authenticates over postMessage (see handleEditorMessage) — no token travels in the URL.
    this.urlEmbeded = this.domSanitizer.bypassSecurityTrustResourceUrl(environment.trendFlow);
    window.addEventListener('message', this.onEditorMessage);
    this.getFlow(this.idFlow);
  }

  override ngOnDestroy(): void {
    window.removeEventListener('message', this.onEditorMessage);
    super.ngOnDestroy();
  }

  // The embedded editor posts 'trendmulti-flow:ready' once it is listening; we reply with the
  // logged user's JWT + the flow id + the API base URL so it can call /api/flow as this user.
  private handleEditorMessage(event: MessageEvent): void {
    if (event.origin !== this.editorOrigin) {
      return;
    }
    if (event.data?.type !== 'trendmulti-flow:ready') {
      return;
    }
    this.sendSessionToEditor();
  }

  private sendSessionToEditor(): void {
    const message = {
      type: 'trendmulti-flow:auth',
      token: super.getCurrentUser()?.token,
      idFlow: this.idFlow,
      apiBaseUrl: environment.apiUrl,
      firebaseConfig: environment.firebase, // public web config — the editor uploads attachments to Firebase Storage (T-10)
    };
    this.flowFrame?.nativeElement?.contentWindow?.postMessage(message, this.editorOrigin);
  }

  private getFlow(idFlow: string) {
    this.flowService.getById(idFlow).subscribe({
      next: (flow: Flow) => this.flow = flow
    });
  }

}
